import { get, post } from '../../../infra/rest';
import requestConfig from '../../../shared/config/request';
import { urlCreator } from '../../../shared/utils/url-helpers';
import { AnswerIncommingCallApiType, Call, CallDirection, CallFromUpdatesApi, ReconnectSDPResponse } from '../typings';

export const answerIncommingCallApi = async ({
  callId,
  sdp,
  sdpType,
  reconnect
}: AnswerIncommingCallApiType): Promise<unknown> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/accept`,
  });

  return post<AnswerIncommingCallApiType>(
    url,
    {
      body: JSON.stringify({
        callId,
        sdp,
        sdpType,
        reconnect
      }),
    },
    true,
    false,
    true
  );
};

export const declineCallApi = async ({
  callId,
}: {
  callId: string;
}): Promise<unknown> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/decline`,
  });
  return post<{ callId: string; wabaNumber: string }>(
    url,
    {
      body: JSON.stringify({
        callId,
      }),
    },
    true,
    false,
    true
  );
};
export const getNewReconnectSDPApi = async ({
  callId,
  callOriginType,
  sdp
}: {
  callId: string;
  callOriginType: CallDirection,
  sdp?: string; // only for outgoing calls
}): Promise<ReconnectSDPResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/reconnect`,
  });
  return post<ReconnectSDPResponse>(
    url,
    {
      body: JSON.stringify({
        callId,
        callOriginType,
        sdp,
      }),
    },
    true,
    false,
    true
  );
};

// Keep-alive ping API to prevent resource leaks during active calls
export const keepAlivePingApi = async ({
  callId
}: {
  callId: string
}): Promise<unknown> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/ping`,
    query: {
      callId
    },
  });

  return get<unknown>(
    url,
    undefined,
    true,
    false,
    true
  );
}

export const getCallsUpdateApi = async (): Promise<{
  activeCalls : CallFromUpdatesApi[]
}> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/updates`,
  });
  return get<{
    activeCalls : CallFromUpdatesApi[]
  }>(url, {}, true, false, true);
};